import { gql, TypedDocumentNode } from "@apollo/client";

import { BitbucketCloudIntegration, QueryBitbucketCloudIntegrationArgs } from "types/generated";

export type BitbucketCloudIntegrationData = Pick<
  BitbucketCloudIntegration,
  | "vcsChecks"
  | "useGitCheckout"
  | "description"
  | "id"
  | "isDefault"
  | "labels"
  | "name"
  | "space"
  | "username"
  | "email"
>;

type GetVCSBitbucketCloudIntegrationQuery = {
  bitbucketCloudIntegration: BitbucketCloudIntegrationData;
};

export const GET_BITBUCKET_CLOUD_INTEGRATION: TypedDocumentNode<
  GetVCSBitbucketCloudIntegrationQuery,
  QueryBitbucketCloudIntegrationArgs
> = gql`
  query GetVCSBitbucketCloudIntegration($id: ID!) {
    bitbucketCloudIntegration(id: $id) {
      vcsChecks
      useGitCheckout
      description
      id
      isDefault
      labels
      name
      space {
        id
        name
        accessLevel
      }
      username
      email
    }
  }
`;
